import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { Procedure } from 'types/procedure';

export type ProcedureValidation = {
  name?: string;
  profit_margin?: string;
};

type UseProcedureValidation = [
  ProcedureValidation,
  Dispatch<SetStateAction<ProcedureValidation>>,
  (procedure: Procedure) => Promise<void>,
];

export function useProcedureValidation(): UseProcedureValidation {
  async function handleValidation(procedure: Procedure) {
    const schema = yup.object().shape({
      profit_margin: yup
        .number()
        .typeError('A margem de lucro é obrigatória')
        .min(0, 'A margem de lucro não pode ser negativa')
        .lessThan(100, 'A margem de lucro deve ser menor que 100%')
        .required('A margem de lucro é obrigatória'),
      name: yup.string().required('O nome do procedimento é obrigatório'),
    });

    try {
      await schema.validate(procedure);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<ProcedureValidation>({});
  return [validation, setValidation, handleValidation];
}
